"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantumExtractor = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var QuantumExtractor = (function (_super) {
    __extends(QuantumExtractor, _super);
    function QuantumExtractor() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.QUANTUM_EXTRACTOR,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.ENERGY],
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 4); }),
            cardDiscount: { tag: Tags_1.Tags.SPACE, amount: 2 },
            metadata: {
                cardNumber: '079',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a Space card, you pay 2 M€ less for it.', function (eb) {
                        eb.space({ played: Options_1.played }).startEffect.megacredits(-2);
                    }).br;
                    b.production(function (pb) { return pb.energy(4, { digit: Options_1.digit }); });
                }),
                description: 'Requires 4 science tags. Increase your energy production 4 steps.',
            },
        }) || this;
    }
    QuantumExtractor.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.SPACE)) {
            return 2;
        }
        return 0;
    };
    QuantumExtractor.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 4);
        return undefined;
    };
    return QuantumExtractor;
}(Card_1.Card));
exports.QuantumExtractor = QuantumExtractor;
